const ALPHABET = '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ'

/**
 * Generate a random ID by choosing `n` characters from ALPHABET.
 *
 * Uses rejection sampling to avoid modulo bias.
 */
export function getRandomId(n: number): string {
  if (!Number.isFinite(n) || n <= 0) return ''

  const alphabet = ALPHABET
  const base = alphabet.length
  // Largest multiple of base that fits in a byte (0..255) for unbiased selection.
  const max = Math.floor(256 / base) * base

  let out = ''
  while (out.length < n) {
    const bytes = new Uint8Array(Math.max(8, n))
    crypto.getRandomValues(bytes)
    for (let i = 0; i < bytes.length && out.length < n; i++) {
      const b = bytes[i]!
      if (b >= max) continue
      out += alphabet[b % base]!
    }
  }
  return out
}


